export default __webpack_public_path__ + "static/media/1623835884090.a0baa291.JPEG";